/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('SaleProductView',["$sce","SaleProductData","SaleProduct","$filter","CurrencyManager","NumberSeparatorType",
        function ($sce,SaleProductData,SaleProduct,$filter,CurrencyManager,NumberSeparatorType)
        {

        var SaleProductView = function (saleProduct,spIndex,billPosition,saleView)
        {
            this.spIndex = spIndex; //model index
            this.posView = (saleView ? saleView.posView : null);
            this.saleView = saleView;
            this.productView = null;
            this.label = "";
            this.price = 0;
            this.priceHT=0;
            this.vat= null;
            this.vatCode = null;
            this.originalPrice = 0;
            this.originalPriceInput = "";
            this.discountPercent = 0;
            this.quantity= 0;
            this.quantityInput= 0;//input value binded
            this.hrView;
            this.billPosition =billPosition;//position inside sale ->
            if (saleProduct)
                this.loadDataFrom(saleProduct);
        }
        SaleProductView.prototype.getModel = function()
        {
            if (this.spIndex!=-1)
            {
                return SaleProductData.getByIndex(this.spIndex);
            }
            return null;
        }
        SaleProductView.prototype.loadDataFrom = function(saleProduct)
        {
            //Assume here than the object in parameter contains only id (must load them)
            if (saleProduct)
            {
                if (saleProduct.product && this.posView && this.posView.domainView)
                    this.productView =  this.posView.domainView.getProductView(saleProduct.product);
                this.label = saleProduct.label;
                this.price= saleProduct.price;
                this.vat= saleProduct.vat;
                if (saleProduct.vatCode)
                    this.vatCode= saleProduct.vatCode;
                this.updatePriceHT();
                if (saleProduct.originalPrice!=null)
                    this.originalPrice = saleProduct.originalPrice;
                else
                    this.originalPrice = this.price;
                this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
                this.discountPercent = saleProduct.discountPercent;
                this.quantity = saleProduct.quantity;
                this.quantityInput = saleProduct.quantity;
                if (saleProduct.humanResource && this.posView && this.posView.domainView)
                    this.hrView = this.posView.domainView.getHrView(saleProduct.humanResource);

            }
        }

        SaleProductView.prototype.copyDataTo = function(saleProduct)
        {
            if (saleProduct)
            {
                saleProduct.label = this.label;
                if (this.productView)
                    saleProduct.product = this.productView.getModel();
                saleProduct.price= this.price;
                saleProduct.originalPrice= this.originalPrice;
                if (this.discountPercent && typeof this.discountPercent ==='string')
                {
                    saleProduct.discountPercent = this.discountPercent.replace(",",".").replace(" ","");
                    saleProduct.discountPercent = parseFloat(saleProduct.discountPercent);
                }
                else
                    saleProduct.discountPercent= this.discountPercent;
                saleProduct.quantity = this.quantity;
                saleProduct.vat= this.vat;
                saleProduct.vatCode= this.vatCode;
                var newBooking = this.saleView.getModel();
                if (saleProduct.sale && newBooking!==saleProduct.sale)//remove
                    saleProduct.sale.removeSaleProduct(saleProduct);
                if (newBooking)//Force add because removed by sale.updateModel
                    newBooking.addSaleProduct(saleProduct);
                if (this.hrView)
                    saleProduct.humanResource = this.hrView.getModel();

            }
        }

        SaleProductView.prototype.getClone = function(saleView)
        {
            var spView = new SaleProductView(null,-1,this.billPosition,saleView)
            spView.label = this.label;
            spView.productView = this.productView;
            spView.price= this.price;
            spView.originalPrice= this.originalPrice;
            spView.vat= this.vat;
            spView.vatCode= this.vatCode;
            spView.originalPriceInput= this.originalPriceInput;
            spView.discountPercent= this.discountPercent;
            spView.quantity= this.quantity;
            spView.quantityInput= this.quantityInput;
            spView.hrView = this.hrView;
            return spView;
        }
        SaleProductView.prototype.selectProduct = function () {
            if (this.productView)
                this.productView.isSelected = true;
        }

        SaleProductView.prototype.updateOriginalPriceInputArrow = function(number)
        {
            if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput!=null && typeof this.originalPriceInput ==='string') {
                var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                var originalPrice = parseFloat(originalPriceStr);
                if(originalPrice !== "NaN")
                    originalPrice+= number;

                this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
                this.originalPrice = originalPrice;
                this.updatePrice();
            }
        }

        SaleProductView.prototype.onOriginalPriceInputChange = function() {
            if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput ==='string') {
                let originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                let originalPrice = parseFloat(originalPriceStr);
                if(originalPrice !== "NaN") {
                    this.originalPrice = originalPrice;
                } else {
                    this.originalPrice = null;
                }
                this.updatePrice();
            }
        }

        SaleProductView.prototype.setProduct = function(productView,isOnInternet, ignoreProductQuantity)
        {
            this.productView = productView;
            if (productView!=null)
            {
                this.label = productView.label;
                this.originalPrice = productView.price;
                this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
                if (productView.hasQuantity && !ignoreProductQuantity)
                    productView.quantity--;
                this.quantity++;
                this.quantityInput++;
                if (productView.vatView) {
                    this.vat = productView.vatView.tax;
                    this.vatCode =  productView.vatView.code;
                }
                else
                    if(this.posView && this.posView.domainView)
                    {
                        let vatView = this.posView.domainView.getDefaultVatView();
                        if (vatView) {
                            this.vat = vatView.tax;
                            this.vatCode = vatView.code;
                        }
                    }
                if (isOnInternet!==undefined && isOnInternet && productView.hasInternetPrice)
                    this.discountPercent = productView.internetDiscountPercent;
                this.updatePrice();

            }
        };

        SaleProductView.prototype.setHrView = function(hrView)
        {
           this.hrView = hrView;
        };
        SaleProductView.prototype.updatePriceHT = function(){
            this.priceHT = Math.round((100/(100+this.vat) * this.price)*100)/100;
        };
        SaleProductView.prototype.onChangeQuantity = function(refuseOverStock)
        {
            let ignoreQuantity = this.saleView != null && this.saleView.isEstimationCost();

            if (this.productView!=null && this.saleView && !this.saleView.isReadOnly)
            {
                if (this.productView.hasQuantity && !ignoreQuantity)
                {
                    var newProductQt = this.productView.quantity+ this.quantity - this.quantityInput;
                    if (refuseOverStock!==undefined && refuseOverStock && newProductQt<0)
                        this.quantityInput = this.quantity;
                    else
                        this.productView.quantity = newProductQt;
                }
                this.quantity = this.quantityInput;
                this.updatePrice();
            }
        };
        SaleProductView.prototype.updateQuantity = function(step,allowOverStock)
        {
            var update = false;
            if(!isNaN(this.quantityInput))
                this.quantityInput = Number(this.quantityInput);
            else if(this.quantityInput == "")
                this.quantityInput = 0;
            if (this.productView!=null && this.saleView && !this.saleView.isReadOnly && (this.quantityInput+step>=0))
            {
                if (this.productView.hasQuantity)
                {
                    var newProductQt = 0;
                    if(step == 0){
                        //if quantity is updated by ng-change (not arrow click), productQt = new quantity - old quantity.
                        newProductQt = this.productView.quantity - (this.quantityInput - this.quantity);
                    }
                    else{
                        newProductQt = this.productView.quantity-step;
                    }

                    if (allowOverStock || newProductQt>=0)
                    {
                        update = true;
                        this.quantityInput +=step;
                    }
                    else if(step == 0 && newProductQt<0){
                        this.quantityInput = this.quantity;
                    }
                }
                else
                {
                    update = true;
                    this.quantityInput +=step;
                }
                if (update)
                    this.onChangeQuantity();
            }
            return update;
        }
        SaleProductView.prototype.increaseDiscountPercent = function(step) {
            if (this.saleView && !this.saleView.isReadOnly) {
                if ((step+this.discountPercent)>100)
                    this.discountPercent = 100;
                else
                    this.discountPercent+=step;
                this.updatePrice();
            }

        }
        SaleProductView.prototype.decreaseDiscountPercent = function(step) {
            if (this.saleView && !this.saleView.isReadOnly) {
                if (this.discountPercent-step<0)
                    this.discountPercent = 0;
                else
                    this.discountPercent-=step;
                this.updatePrice();
            }

        }
        SaleProductView.prototype.updatePrice = function()
        {
            var oriPrice = this.originalPrice*this.quantity;
            var discount = 0;
            var discountPercent =this.discountPercent;
            if (this.discountPercent && typeof this.discountPercent ==='string')
            {
                discountPercent = this.discountPercent.replace(",",".").replace(" ","");
                discountPercent = parseFloat(discountPercent);
            }
            if (discountPercent!=0)
                discount = Math.round((discountPercent *  oriPrice / 100)*100)/100;

            if ((oriPrice-discount)!=this.price)
            {
                this.price = (oriPrice-discount);
                this.updatePriceHT();
                this.saleView.resetPayments();
                this.saleView.calculateSaleFields();
            }
            this.saleView.checkForInvalidAmounts();

        }
        SaleProductView.prototype.updateModel = function(previousSaleStatus)
        {
            var saleProduct = this.getModel();
            if (saleProduct==null)
            {
                saleProduct = new SaleProduct();
                this.spIndex = SaleProductData.getIndexOf(saleProduct);
            }
            else
                if (saleProduct.product && saleProduct.product.hasQuantity && previousSaleStatus !== 'estimation')//add quantity to old product
                    saleProduct.product.quantity+=saleProduct.quantity;
            this.copyDataTo(saleProduct);
            if (saleProduct.product && saleProduct.product.hasQuantity && this.saleView && (this.saleView.status === "advance" || this.saleView.status === "waiting" || this.saleView.status === "sold"))
                saleProduct.product.quantity -= saleProduct.quantity;
        }

        SaleProductView.prototype.removeModel = function()
        {
            var saleProduct = this.getModel();
            if (saleProduct && saleProduct.product && saleProduct.product.hasQuantity)//add quantity to old product
                saleProduct.product.quantity+=saleProduct.quantity;
        }
        SaleProductView.prototype.reloadModel = function()
        {
            var saleProduct = this.getModel();
            if (saleProduct==null)
            {
                //this.parentCategoryView.removeSaleProductView(this);
            }
            else
            {
                this.loadDataFrom(saleProduct);
            }
        }


        SaleProductView.prototype.canSave = function()
        {
            if (!this.productView)
                return false;
            var quantityInt = parseInt(this.quantity);
            if(quantityInt !== "NaN" && quantityInt !== "")
            {
                this.quantity = quantityInt;
            }
            else
            {
                this.quantity = null;
            }
            var priceFloat = parseFloat(this.price);
            if(priceFloat !== "NaN" && priceFloat !== "")
            {
                this.price = priceFloat;
            }
            else
            {
                this.price = "";
            }

            if
            (
                (this.label && this.label!="") //titre
                && (this.price && this.price>=0) //prix (décimal)
                && (this.quantity!=null && this.quantity>0) //durée (entier)
            )
            { return true; }
            else
            { return false; }
        }

        return SaleProductView;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/views/SaleProductView.js